export const INTERNAL_NOTE_MAX_LENGTH = 250
